var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.0004888,12C2.6917624,12,0,9.3084574,0,6s2.6917624-6,6.0004888-6S12,2.6915431,12,6S9.3092155,12,6.0004888,12z  M6.0004888,1.2005866C3.3537033,1.2005866,1.2006844,3.35343,1.2006844,6s2.153019,4.7994137,4.7998042,4.7994137 c2.6458077,0,4.7988267-2.1528435,4.7988267-4.7994137S8.6462965,1.2005866,6.0004888,1.2005866z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.2565475,8.4868212c0-0.4061975,0.3321953-0.7478609,0.7390699-0.7478609 c0.4062309,0,0.7480826,0.3416634,0.7480826,0.7478609c0,0.3971853-0.3418517,0.7386875-0.7480826,0.7386875 C5.5887427,9.2255087,5.2565475,8.8840065,5.2565475,8.4868212z M5.4780111,7.1295028L5.2842307,2.9745054h1.4131165 L6.5125799,7.1295028H5.4780111z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.c7bc2ffbeb87fea50f364bc0c21de119.svg";
export { ForwardRef as ReactComponent };